export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-transition/~/d3-interpolate/src/number.js
// module id = 8WrI
// module chunks = 0